import { render, staticRenderFns } from "./OmsTheme.vue?vue&type=template&id=1884b516"
import script from "./OmsTheme.vue?vue&type=script&lang=js"
export * from "./OmsTheme.vue?vue&type=script&lang=js"
import style0 from "./OmsTheme.vue?vue&type=style&index=0&id=1884b516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports